import { POST } from './API';

const PATH_ROOT = 'U007';

export async function A01(
  username: string,
  lang: string,
  cancellation?: AbortSignal
): Promise<{
  status: string;
  msg: string;
}> {
  return await POST(`${PATH_ROOT}/forget_password`, {
    username: username,
    lang: lang,
    signal: cancellation,
  });
}

export type A02Request = {
  username: string;
  verification_code: string;
  new_password: string;
};
export async function A02(
  request: A02Request,
  cancellation?: AbortSignal
): Promise<{
  status: string;
  msg: string;
}> {
  return await POST(`${PATH_ROOT}/update_password`, request, false, cancellation);
}
